// services/appointment.services.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IAppointment } from "../appointmentModal";
import moment from "moment";

export const getAllAppointments = createAsyncThunk(
  "Appointment/FindAllAppointment",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Appointment/FindAllAppointment`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Appointments:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createAppointment = createAsyncThunk(
  "Appointment/InsertAppointment",
  async (appointmentData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Appointment/InsertAppointment`,
        appointmentData,
      );
      SuccessToast(
        response.data?.Details || "Appointment created successfully",
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Appointment:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateAppointment = createAsyncThunk(
  "Appointment/UpdateAppointment",
  async (appointmentData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Appointment/UpdateAppointment`,
        appointmentData,
      );
      SuccessToast(
        response.data?.Details || "Appointment updated successfully",
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Appointment:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteAppointment = createAsyncThunk(
  "Appointment/DeleteAppointment",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Appointment/DeleteAppointment`,
        { ID },
      );
      SuccessToast(
        response.data?.Details || "Appointment deleted successfully",
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Appointment:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAppointmentByID = createAsyncThunk(
  "Appointment/FindByIDAppointment",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Appointment/FindByIDAppointment`,
        { ID },
      );
      const result = response.data?.Data;
      return {
        ID: result?.ID,
        DoctorID: result?.DoctorID,
        DoctorName: result?.DoctorName,
        Fees: result?.Fees,
        Date: result?.Date ? moment(result?.Date, "YYYY-MM-DD").toDate() : null,
        AvailableTimeSlot: result?.AvailableTimeSlot ?? "",
        PatientName: result?.PatientName ?? "",
        MobileNo: result?.MobileNo ?? "",
        EmailID: result?.EmailID ?? "",
        ReasonForVisit: result?.ReasonForVisit ?? "",
        IsActive: result?.IsActive ? 1 : 2,
      } as IAppointment;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Appointment:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAppointmentsByDoctorID = createAsyncThunk(
  "Appointment/DoctorIDAppointment",
  async (DoctorID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Appointment/DoctorIDAppointment`,
        { DoctorID },
      );
      return response.data?.Data || [];
    } catch (error: any) {
      console.error("Error Fetching Appointments by Doctor:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
